const Theme = {
  primaryColor: "#ec1d24",
  primaryHoverColor: "#ec1d24",
  primaryHoverUnderLineColor: "#ec1d24",
  secondaryHoverUnderLineColor: "transparent",
  secondaryColor: "#3a3a3a",
  secondaryHoverColor: "#ec1d24",
  sectionBackground: "#f8f8f8",
  underlineColor: "#37312f",
  mainTextColor: "#000000",
  disable: "#cccccc",

  mobileBreakpoint: "1000px",
  appHorizontalPadding: "15px",

  '$weight-regular': '400',
  '$weight-semibold': '500',
  '$weight-bold': '600',

   // FONT SIZES
  '$font-size-xxxs': '14px',
  '$font-size-xxs': '16px',
  '$font-size-xs': '20px',
  '$font-size-sm': '26px',
  '$font-size-md': '36px',
  '$font-size-lg': '42px',
  '$font-size-lgxl': '48px',
  '$font-size-xl': '64px',
  '$font-size-xxl': '86px',
  '$font-size-xxxl': '112px',

  '$thin-border': '20px', 
  '$thick-border': '40px',

  '$font-primary-medium': "Lato, sans-serif",
  '$font-secondary-medium': "Cormorant Garamond, serif",
  '$font-quotes': "Cormorant Medium",
}

export default Theme;